"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var config_js_1 = require("../config.js");

var auth_1 = __importDefault(require("./auth"));

exports.default = {
  API: function API(env, customApiUrl) {
    if (env === void 0) {
      env = config_js_1.Environments.PRODUCTION;
    }

    return {
      login: function login(user) {
        return auth_1.default(env, customApiUrl).postSessions(user);
      },
      signup: function signup(user) {
        return auth_1.default(env, customApiUrl).postRegistrations(user);
      },
      updateRegistration: function updateRegistration(data, token, email) {
        return auth_1.default(env, customApiUrl).putRegistrations(data, token, email);
      },
      confirmAccount: function confirmAccount(token) {
        return auth_1.default(env, customApiUrl).getConfirmations(token);
      },
      unlockAccount: function unlockAccount(email) {
        return auth_1.default(env, customApiUrl).postUnlockAccount(email);
      },
      resendConfirmation: function resendConfirmation(email) {
        return auth_1.default(env, customApiUrl).postConfirmations(email);
      },
      logout: function logout(token, email) {
        return auth_1.default(env, customApiUrl).deleteSessions(token, email);
      },
      sendPasswordResetEmail: function sendPasswordResetEmail(user) {
        return auth_1.default(env, customApiUrl).postPasswords(user);
      },
      resetPassword: function resetPassword(token, password, confirmPassword) {
        return auth_1.default(env, customApiUrl).putPasswords(token, password, confirmPassword);
      },
      googleAuth: function googleAuth(token) {
        return auth_1.default(env, customApiUrl).omniAuths('google_oauth2', token);
      },
      updateUserData: function updateUserData(id, data, token, email) {
        return auth_1.default(env, customApiUrl).putUserData(id, data, token, email);
      },
      updateUser: function updateUser(data, token, email) {
        return auth_1.default(env, customApiUrl).putUser(data, token, email);
      },
      registerBetaUser: function registerBetaUser(data) {
        return auth_1.default(env, customApiUrl).postRegisterBetaUser(data);
      }
    };
  }
};